module.exports = __webpack_public_path__ + "assets/img/goldsun-brooch.49b0543b.png";